import { DatePicker, Divider, Group, Modal, Select } from '@byecode/ui'
import type { NodeTypes, ScheduledTriggerConfig, ScheduledTriggerRule } from '@lighthouse/shared'
import { ListItem4ByecodeUi, TriggerNodeType, triggerNodeTypeCustomOptions } from '@lighthouse/shared'
import { isValid } from 'date-fns'
import React from 'react'

import * as SC from '../../styles'
import { CommonRule } from './CommonRule'

interface ScheduledTriggerConfigureProps {
    nodeType: NodeTypes
    onNodeTypeChange: (val: NodeTypes) => void
    onNodeNameChange: (name: string) => void
    value?: ScheduledTriggerConfig
    onChange?: (value: ScheduledTriggerConfig) => void
}

export const ScheduledTriggerConfigure: React.FC<ScheduledTriggerConfigureProps> = ({
    nodeType,
    onNodeTypeChange,
    onNodeNameChange,
    value = {} as ScheduledTriggerConfig,
    onChange
}) => {
    const scheduleRule: ScheduledTriggerRule = value?.scheduleRule ?? 'ONCE'

    const isTriggerOnce = scheduleRule === 'ONCE'

    return (
        <>
            <SC.Container>
                <Group label="触发">
                    <ListItem4ByecodeUi>
                        <SC.FormItemLabelWrapper>
                            <SC.FormItemLabel>触发方式</SC.FormItemLabel>
                        </SC.FormItemLabelWrapper>
                        <SC.FormItemContent>
                            <Select
                                value={nodeType}
                                options={triggerNodeTypeCustomOptions}
                                onChange={async val => {
                                    const nextName = triggerNodeTypeCustomOptions.find(item => item.value === val)?.label
                                    if (nextName) {
                                        onNodeNameChange(nextName)
                                    }
                                    onNodeTypeChange(val as NodeTypes)
                                }}
                            />
                        </SC.FormItemContent>
                    </ListItem4ByecodeUi>
                    <ListItem4ByecodeUi>
                        <SC.FormItemLabelWrapper>
                            <SC.FormItemLabel required>开始时间</SC.FormItemLabel>
                        </SC.FormItemLabelWrapper>
                        <SC.FormItemContent>
                            {(() => {
                                const raw = value?.scheduleStartTime
                                const dateValue = raw && isValid(new Date(raw)) ? new Date(raw) : undefined
                                return (
                                    <DatePicker
                                        clearable
                                        value={dateValue}
                                        showTime
                                        onChange={val => onChange?.({ ...value, scheduleStartTime: val })}
                                        onClear={() => onChange?.({ ...value, scheduleStartTime: undefined })}
                                    />
                                )
                            })()}
                        </SC.FormItemContent>
                    </ListItem4ByecodeUi>
                    {!isTriggerOnce && (
                        <ListItem4ByecodeUi>
                            <SC.FormItemLabelWrapper>
                                <SC.FormItemLabel>结束时间</SC.FormItemLabel>
                            </SC.FormItemLabelWrapper>
                            <SC.FormItemContent>
                                {(() => {
                                    const raw = value?.scheduleEndTime
                                    const dateValue = raw && isValid(new Date(raw)) ? new Date(raw) : undefined
                                    return (
                                        <DatePicker
                                            clearable
                                            value={dateValue}
                                            showTime
                                            onChange={val => onChange?.({ ...value, scheduleEndTime: val })}
                                            onClear={() => onChange?.({ ...value, scheduleEndTime: undefined })}
                                        />
                                    )
                                })()}
                            </SC.FormItemContent>
                        </ListItem4ByecodeUi>
                    )}
                </Group>
                <Divider />
                <CommonRule value={value} onChange={val => onChange?.(val)} />
            </SC.Container>
        </>
    )
}
